module.exports = __webpack_public_path__ + "static/img/ramadankenzy.f7e11d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ramadankenzy.png
// module id = qQCu
// module chunks = 7